import React, {useState, useEffect} from 'react';
import userController from '../../../../../../controllers/usercontroller'; 
import { Link } from 'react-router-dom';
import Chip from '../../../common/Chip';
import './styles.css';

const BlogItem = ({
  blog: {
    id,
    img,
    title,
    content,
    author,
    createdAt
  },
}) => {

  let [firstRender, setFirstRender] = useState({
      firstRender: true,
  });

  const [user, setUser] = useState({
    displayName: ''
  });

  const getUserDetails = async (uid) => {
    await userController.getUserDetails(uid, 'users').then((value)=>{
      if(value != null){
          setUser(value);
      }
    });
  };

  useEffect(() => {
    if(firstRender && author !== undefined){
      getUserDetails(author).then(data => {
          if(data != null){
              setUser(data);
              setFirstRender(false);
          }
      });
    }
  }, [])

  return (
    <Link className='blogItem-link' to={`/news/${id}`}>
    <div className='blogItem-wrap'>
      <img className='blogItem-cover' src={img} alt='cover' />
      {/* <Chip label={author} /> */}
      <h3>{title}</h3>
      <p className='blogItem-desc'>{content}</p>
      <footer>
        <div className='blogItem-author'>
          <div>
            <h6><span className='pub_name'>publié par</span> {user.displayName}</h6>
            <p>{Date(createdAt).toLocaleString()}</p>
          </div>
        </div>
      </footer>
    </div>
  </Link>
  );
};

export default BlogItem;
